import { useUIStore } from '@/stores/ui.store'

export function useTheme() {
  const theme = useUIStore((s) => s.theme)
  const resolvedTheme = useUIStore((s) => s.resolvedTheme)
  const setTheme = useUIStore((s) => s.setTheme)

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')
  }

  return { theme, resolvedTheme, setTheme, toggleTheme }
}
